import type { Chat } from "@rhema/client";
import type { Format } from "@rhema/format";
import { RichText } from "@rhema/ui";
import { useMemo } from "react";
import { mentionNames, useRichRender } from "./rich";

/**
 * A caption with each @mention picked out in gold and its links made clickable. An edited
 * caption written with formatting shows it.
 */
export function TextWithMentions({
  body,
  mentions,
  chat,
  format,
}: {
  body: string;
  mentions?: string[];
  chat: Chat;
  format?: Format;
}) {
  const render = useRichRender(chat);
  const key = (mentions ?? []).join();
  // biome-ignore lint/correctness/useExhaustiveDependencies: the ids and members stand for the names
  const names = useMemo(() => mentionNames(chat, mentions), [key, chat.members]);
  return <RichText body={body} format={format} mentions={names} {...render} />;
}

/** The ids of the people whose @Name is still in the text, from the names picked while typing. */
export function mentionIds(text: string, picked: Map<string, string>): string[] {
  return [...picked.entries()].filter(([name]) => text.includes(`@${name}`)).map(([, id]) => id);
}
